import { User } from "../../types/user";
import Api from "../api";

export default async function apiGetUser(id: string) {
  return await Api.get<User>({
    input: `/api/v1/user/${id}`,
  });
}
